import { render, staticRenderFns } from "./AppDate.vue?vue&type=template&id=6fbb2a81&lang=pug&"
import script from "./AppDate.vue?vue&type=script&lang=js&"
export * from "./AppDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports